// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import "./Dashboard.css";
// import { Progressbar, Underline } from "../../widgets";
// import { Table, Sidenavbar, Dash_radialmenu } from "../../components";
// import {
//   radmenu,
//   sidenav,
// } from "../../constants/dashboard";
// import { FaRegEye, FaChevronDown } from "react-icons/fa";
// import { IoEyeOffOutline } from "react-icons/io5";
// import Loader from "../../containers/Loader/Loader";

// const Dashboard = () => {
//   const [activeTab, setActiveTab] = useState("profile");
//   const [stud_details, setStud_details] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [menu_open, setmenu_open] = useState(false);
//   // //result states start
//   // const [sem_opt_flag, setSem_opt_flag] = useState(false);
//   // const [results, setResults] = useState([]);
//   // const [sem_list, setSem_list] = useState([]);
//   const [sem, setSem] = useState("");
//   const [dept, setDept] = useState("");
//   const [cgpa, setCgpa] = useState("");
//   //result states end

//   const [pflag, setPFlag] = useState(null);
//   const [showChangePasswordDialog, setShowChangePasswordDialog] =
//     useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const [pswderror, setPswderror] = useState("");
//   const [strength, setStrength] = useState("");
//   const [bloodGroup, setBloodGroup] = useState("");
//   const [hosteller, setHosteller] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation(); 

//   const [show, setShow] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   function togglePassword() {
//     setShow(!show);
//   }

//   // determine if the current student is eligible for the extra input fields
//   const is_first_year = (() => {
//     const regno = stud_details.regno || (location && location.state && location.state.regno) || "";
//     return /^917625(11|12|13|14|15|16)[01][0-9]{2}$/.test(String(regno));
//   })();

//   useEffect(() => {
//     if (location.state && location.state.pflag) {
//       // console.log("pflag value:", location.state.pflag);
//       if (location.state.pflag === 1) {
//         console.log("pflag is 1, showing change password dialog");
//         setShowChangePasswordDialog(true);
//         localStorage.setItem("updateDetailsRequired", "true");
//       }
//     } else {
//       // Check if update details dialog was previously shown but not completed
//       const required = localStorage.getItem("updateDetailsRequired");
//       if (required === "true") {
//         setShowChangePasswordDialog(true);
//       }
//     }
//   }, [location.state]);

//   const password_strength = (pswd) => {
//     const strongRegex =
//       /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{8,}$/;
//     const mediumRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/;

//     if (strongRegex.test(pswd)) {
//       setStrength("Strong");
//     } else if (mediumRegex.test(pswd)) {
//       setStrength("Medium");
//     } else {
//       setStrength("Weak");
//     }
//   };

//   const handleChangePassword = async () => {
//     let pflag = 0;
//     try {
//       // console.log("New psswd from user:", newPassword);
//       // console.log("regno:", location.state.regno);
//       if (newPassword.length === 0) {
//         setPswderror("Enter Password");
//         return false;
//       } else if (is_first_year && !bloodGroup) {
//         setPswderror("Select Blood Group");
//         return false;
//       }
//       else if (is_first_year && !hosteller) {
//         setPswderror("Select Hosteller Status");
//         return false;
//       } else {
//         pflag = 1;
//         setPswderror("");
//       }

//       if (pflag === 1 && strength === "Strong") {
//         const response = await axios.post("/backend/reset-pswd", {
//           regno: location.state.regno,
//           password: newPassword,
//           // bloodGroup: bloodGroup,
//         });

//         if (response.data.message === "Password reset successfully") {
//           setPFlag(2);
//           return true;
//         } else {
//           console.error("Password reset failed");
//           return false;
//         }
//       }
//       return false;
//     } catch (error) {
//       console.error("Error resetting password:", error);
//       return false;
//     }
//   };
//   const handleDashboardData = (data) => {
//     setDept(data.dept);

//     if (data.Status === "Success") {
//       const access = data.stud_details.access;

//       if (access === "admin") {
//         navigate("/admin-panel", { replace: true });
//       } else if (access === "feedbackadmin") {
//         navigate("/FeedbackPdf", { replace: true });
//       } else {
//         setStud_details(data.stud_details);
//         setCgpa(data.stud_cgpa); // Set CGPA state with the value from the response
//       }
//     } else {
//       navigate("/login-page", { replace: true });
//     }
//   };

//   const refetchDashboardData = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get("/backend/dashboard");
//       handleDashboardData(response.data);
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     // const cachedData = localStorage.getItem("dashboardData");

//     // if (cachedData) {
//     //   // ✅ Use cached data
//     //   const data = JSON.parse(cachedData);
//     //   handleDashboardData(data);
//     //   return; // ✅ prevent API call
//     // }

//     // // ✅ No cache → call API
//     // setLoading(true);
//     const controller = new AbortController();
//     let mounted = true;

//     setLoading(true);
//     axios
//       .get("/backend/dashboard", { signal: controller.signal })
//       .then((res) => {
//         if (!mounted) return;
//         handleDashboardData(res.data);
//       })
//       .catch((err) => {
//         if (axios.isCancel && axios.isCancel(err)) return;
//         console.log(err);
//       })
//       .finally(() => {
//         if (mounted) setLoading(false);
//       });

//     return () => {
//       mounted = false;
//       controller.abort();
//     };
//   }, [navigate]);

//   useEffect(() => {
//     document.title = "ACCET-Student Dashboard";
//   }, []);

//   useEffect(() => {
//     const handleRadialdis = () => {
//       if (window.innerWidth > 800) {
//         setmenu_open(false);
//       }
//     };
//     window.addEventListener("resize", handleRadialdis);
//   }, []);

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//   };
//   const handleUpdateDetails = async () => {
//     try {
//       const response = await axios.post("/backend/update_details", {
//         regno: stud_details.regno,
//         bloodGroup: bloodGroup,
//         hosteller: hosteller,
//       });
//       if (response.data.Status === "Success") {
//         console.log("Details updated successfully");
//         return true;
//       } else {
//         console.error("Failed to update details");
//         return false;
//       }
//     } catch (error) {
//       console.error("Error updating details:", error);
//       return false;
//     }
//   };

//   const toggle_menu = () => {
//     setmenu_open(!menu_open);
//   };

//   return (
//     <div>
//       <div className="dashboard-container">
//         {loading && <Loader />}
//         {showChangePasswordDialog && (
//           <div className="password_dialog_outer">
//             <div className="password_change_dialog">
//               <h2>Update Details</h2>
//               {/* <Underline heading={"Set Password"} /> */}
//               {strength && (
//                 <div className="dashboard_pass_strength">
//                   Password strength:&nbsp;
//                   {strength === "Strong" && (
//                     <span className="password_str">{strength}</span>
//                   )}
//                   {strength === "Medium" && (
//                     <span className="password_med">{strength}</span>
//                   )}
//                   {strength === "Weak" && (
//                     <span className="password_weak">{strength}</span>
//                   )}
//                 </div>
//               )}
//               {pswderror && <div className="login_err_msg">{pswderror}</div>}
//               <div className="dashboard_form-control">
//                 <input
//                   className="pswdbox"
//                   type={show ? "text" : "password"}
//                   placeholder="Enter new password"
//                   value={newPassword}
//                   onChange={(e) => {
//                     password_strength(e.target.value);
//                     setNewPassword(e.target.value);
//                     }}
//                   />
//                   <i className="fa fa-lock set_new_pass_lock"></i>
//                   <i
//                     className="fa_eye_icon set_new_pass_eye"
//                     onClick={togglePassword}
//                   >
//                     {show ? <IoEyeOffOutline /> : <FaRegEye />}
//                   </i>
//                   </div>
//                   {is_first_year && (
//                   <>
//                     <div className="dashboard_form-control">
//                     <select
//                       className="pswdbox blood-select"
//                       value={bloodGroup}
//                       onChange={(e) => setBloodGroup(e.target.value)}
//                     ><option value="">Blood Group</option>
//                       <option value="O+">O+</option>
//                       <option value="O-">O-</option>

//                       <option value="A+">A+</option>
//                       <option value="A-">A-</option>

//                       <option value="B+">B+</option>
//                       <option value="B-">B-</option>

//                       <option value="AB+">AB+</option>
//                       <option value="AB-">AB-</option>

//                       <option value="A1+">A1+</option>
//                       <option value="A1-">A1-</option>

//                       <option value="A2+">A2+</option>
//                       <option value="A2-">A2-</option>

//                       <option value="A1B+">A1B+</option>
//                       <option value="A1B-">A1B-</option>

//                       <option value="A2B+">A2B+</option>
//                       <option value="A2B-">A2B-</option>

//                     </select>
//                     <FaChevronDown className="blood-select-icon" />
//                     </div>
//                     <div className="dashboard_form-control">
//                     <select
//                       className="pswdbox blood-select"
//                       value={hosteller}
//                       onChange={(e) => setHosteller(e.target.value)}
//                     >
//                       <option value="" disabled>Hosteller</option>
//                       <option value="Yes">Yes</option>
//                       <option value="No">No</option>
//                     </select>
//                     <FaChevronDown className="blood-select-icon" />
//                     </div>
//                   </>
//                   )}
//                   <button
//                   className="pswdboxsubmit"
//                   disabled={strength !== "Strong" || isSubmitting}
//                   onClick={async () => {
//                     // Validation before submitting
//                     if (!newPassword) {
//                     setPswderror("Enter Password");
//                     return;
//                     }
//                     if (strength !== "Strong") {
//                     setPswderror("Password must be Strong");
//                     return;
//                     }
//                     if (is_first_year && !bloodGroup) {
//                     setPswderror("Select Blood Group");
//                     return;
//                     }
//                     if (is_first_year && !hosteller) {
//                     setPswderror("Select Hosteller Status");
//                     return;
//                     }

//                     setIsSubmitting(true);
//                     try {
//                     let updateSuccess = true;
//                     let passwordSuccess = true;

//                     // Call update details if first year
//                     if (is_first_year) {
//                       updateSuccess = await handleUpdateDetails();
//                     }

//                     // Call change password
//                     console.log("gfgjfxg");
//                     passwordSuccess = await handleChangePassword();
//                     console.log("Password success:", passwordSuccess, "Update success:", updateSuccess);
//                     // Only close dialog and refetch if both operations succeeded
//                     if (passwordSuccess && (updateSuccess || !is_first_year)) {
//                       setShowChangePasswordDialog(false);
//                       localStorage.removeItem("updateDetailsRequired");
//                       await refetchDashboardData();
//                     }
//                     } catch (error) {
//                     console.error("Error during submission:", error);
//                     } finally {
//                     setIsSubmitting(false);
//                     }
//                   }}
//                   >
//                   {isSubmitting ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//                 </div>
//               )}
//               {/* sidenavbar */}
//         <div className="dash_complete_div">
//           <Sidenavbar links={sidenav} dash_state={0} />

//           <div className="profile-sec">
//             {activeTab === "profile" && (
//               <div>
//                 <Underline heading={"Profile Details"} />
//                 <div className="dash_detail_grid_holder">
//                   <div className="trial_dash detail_grid detail_item_1 bgcolour_var_3">
//                     <div className="detail_body txcolour_var_3 ">
//                       {stud_details.studentname}
//                     </div>
//                     <div className="detail_head">Name</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_2 bgcolour_var_5">
//                     <div className="detail_body txcolour_var_2 dash-bar">
//                       <Progressbar
//                         key={1}
//                         percent1={cgpa * 10}
//                         display1={cgpa}
//                         symbol={""}
//                         heading={"CGPA"}
//                       />
//                     </div>
//                     <div className="detail_head">CGPA</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_3 bgcolour_var_2">
//                     <div className="detail_body txcolour_var_2 dept_name">
//                       {dept !== undefined ? dept.toUpperCase() : ""}{" "}
//                       {stud_details.batch}
//                     </div>
//                     <div className="detail_head">Department</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_4 bgcolour_var_3">
//                     <div className="detail_body txcolour_var_3">
//                       {stud_details.regno}
//                     </div>
//                     <div className="detail_head">Register Number</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_5 bgcolour_var_3">
//                     <div className="detail_body txcolour_var_3 d-emis">
//                       {stud_details.emis_no}
//                     </div>
//                     <div className="detail_head">UMIS Number</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_6 bgcolour_var_2">
//                     <div className="detail_body ">{stud_details.gender}</div>
//                     <div className="detail_head">Gender</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_7 bgcolour_var_3">
//                     <div className="detail_body txcolour_var_3">
//                       {stud_details.blood_grp}
//                     </div>
//                     <div className="detail_head">Blood Group</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_8 bgcolour_var_2">
//                     <div className="detail_body txcolour_var_2">
//                       {stud_details.dob}
//                     </div>
//                     <div className="detail_head">DOB</div>
//                   </div>

//                   <div className="trial_dash detail_grid detail_item_9 bgcolour_var_2">
//                     <div className="detail_body txcolour_var_2">
//                       {stud_details.phoneno}
//                     </div>
//                     <div className="detail_head">Mobile Number</div>
//                   </div>
//                   <div className="trial_dash detail_grid detail_item_10 bgcolour_var_3">
//                     <div className="detail_body txcolour_var_3">
//                       {stud_details.mailid}
//                     </div>
//                     <div className="detail_head">Email</div>
//                   </div>
//                 </div>
//                 <div className="logout_button">
//                   <a className="log_link" href="/logout">
//                     Logout
//                   </a>
//                 </div>
//                 {/* <div className="trial_dash">{reg}</div> */}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Dash_radialmenu menu_links={radmenu} />
//     </div>
//   );
// };

// export default Dashboard;
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./Dashboard.css";
import { Progressbar, Underline } from "../../widgets";
import { Table, Sidenavbar, Dash_radialmenu } from "../../components";
import { radmenu, sidenav } from "../../constants/dashboard";
import { FaRegEye, FaChevronDown } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import Loader from "../../containers/Loader/Loader";
import { useQuery, useMutation } from "@tanstack/react-query";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("profile");
  ///const [stud_details, setStud_details] = useState({});
  const [menu_open, setmenu_open] = useState(false);
  

  const [sem, setSem] = useState("");
  //const [dept, setDept] = useState("");

  const [pflag, setPFlag] = useState(null);
  const [showChangePasswordDialog, setShowChangePasswordDialog] =
    useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [pswderror, setPswderror] = useState("");
  const [strength, setStrength] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [hosteller, setHosteller] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const [show, setShow] = useState(false);

  function togglePassword() {
    setShow(!show);
  }

  useEffect(() => {
    if (location.state && location.state.pflag) {
      if (location.state.pflag === 1) {
        setShowChangePasswordDialog(true);
      }
    }
  }, [location.state]);

  const password_strength = (pswd) => {
    const strongRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{8,}$/;
    const mediumRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/;

    if (strongRegex.test(pswd)) {
      setStrength("Strong");
    } else if (mediumRegex.test(pswd)) {
      setStrength("Medium");
    } else {
      setStrength("Weak");
    }
  };

//   const handleDashboardData = (data) => {
//     setDept(data.dept);

//     if (data.Status === "Success") {
//       const access = data.stud_details.access;

//       if (access === "admin") {
//         navigate("/admin-panel", { replace: true });
//       } else if (access === "feedbackadmin") {
//         navigate("/FeedbackPdf", { replace: true });
//       } else {
//         setStud_details(data.stud_details);
//       }
//     } else {
//       navigate("/login-page", { replace: true });
//     }
//   };

//  // ================= DASHBOARD QUERY =================

//   const {
//     isLoading: loading,
//     refetch: refetchDashboardData,
//   } = useQuery({
//     queryKey: ["dashboard"],
//     queryFn: async () => {
//       const response = await axios.get("/backend/dashboard");
//       handleDashboardData(response.data);
//       return response.data;
//     },

//     staleTime: 5 * 60 * 1000,   // 5 minutes fresh
//     gcTime: 10 * 60 * 1000,    // 10 minutes in cache
//   });


const {
  data,
  isLoading: loading,
  refetch: refetchDashboardData,
} = useQuery({
  queryKey: ["dashboard"],
  queryFn: async () => {
    const response = await axios.get("/backend/dashboard");
    return response.data;
  },
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
});

const stud_details = data?.stud_details || {};
const dept = data?.dept || "";
const cgpa = data?.stud_cgpa;

useEffect(() => {
  if (!data) return;

  if (data.Status === "Success") {
    const access = data.stud_details.access;

    if (access === "admin") {
      navigate("/admin-panel", { replace: true });
    } else if (access === "feedbackadmin") {
      navigate("/FeedbackPdf", { replace: true });
    }
  } else {
    navigate("/login-page", { replace: true });
  }
}, [data]);

  const resetPasswordMutation = useMutation({
    mutationFn: (payload) => axios.post("/backend/reset-pswd", payload),
    onSuccess: async (response) => {
      if (response.data.message === "Password reset successfully") {
        setShowChangePasswordDialog(false);
        setPFlag(2);
        await refetchDashboardData();
      }
    },
  });

  

  const updateDetailsMutation = useMutation({
    mutationFn: (payload) => axios.post("/backend/update_details", payload),
    onSuccess: async (response) => {
      if (response.data.Status === "Success") {
        await refetchDashboardData();
      }
    },
  });

  const handleChangePassword = async () => {
    let flag = 0;

    if (newPassword.length === 0) {
      setPswderror("Enter Password");
    } else if (!bloodGroup) {
      setPswderror("Select Blood Group");
    } else {
      flag = 1;
      setPswderror("");
    }

    if (flag === 1 && strength === "Strong") {
      resetPasswordMutation.mutate({
        regno: location.state.regno,
        password: newPassword,
      });
    }
  };

  const handleUpdateDetails = async () => {
    updateDetailsMutation.mutate({
      regno: stud_details.regno,
      bloodGroup: bloodGroup,
      hosteller: hosteller,
    });
  };

  useEffect(() => {
    document.title = "ACCET-Student Dashboard";
  }, []);

  useEffect(() => {
    const handleRadialdis = () => {
      if (window.innerWidth > 800) {
        setmenu_open(false);
      }
    };
    window.addEventListener("resize", handleRadialdis);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const toggle_menu = () => {
    setmenu_open(!menu_open);
  };

  return (
    <div>
      <div className="dashboard-container">
        {loading && <Loader />}
        {showChangePasswordDialog && (
          <div className="password_dialog_outer">
            <div className="password_change_dialog">
              <h2>Update Details</h2>

              {strength && (
                <div className="dashboard_pass_strength">
                  Password strength:&nbsp;
                  {strength === "Strong" && (
                    <span className="password_str">{strength}</span>
                  )}
                  {strength === "Medium" && (
                    <span className="password_med">{strength}</span>
                  )}
                  {strength === "Weak" && (
                    <span className="password_weak">{strength}</span>
                  )}
                </div>
              )}

              {pswderror && <div className="login_err_msg">{pswderror}</div>}

              <div className="dashboard_form-control">
                <input
                  className="pswdbox"
                  type={show ? "text" : "password"}
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => {
                    password_strength(e.target.value);
                    setNewPassword(e.target.value);
                  }}
                />
                <i
                  className="fa_eye_icon set_new_pass_eye"
                  onClick={togglePassword}
                >
                  {show ? <IoEyeOffOutline /> : <FaRegEye />}
                </i>
              </div>

              <div className="dashboard_form-control">
                <select
                  className="pswdbox blood-select"
                  value={bloodGroup}
                  onChange={(e) => setBloodGroup(e.target.value)}
                >
                  <option value="" disabled>Select blood group</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="A1+">A1+</option>
                  <option value="A1B+">A1B+</option>
                  <option value="O-">O-</option>
                </select>
                <FaChevronDown className="blood-select-icon" />
              </div>

              <div className="dashboard_form-control">
                <select
                  className="pswdbox blood-select"
                  value={hosteller}
                  onChange={(e) => setHosteller(e.target.value)}
                >
                  <option value="" disabled>Hosteller</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <FaChevronDown className="blood-select-icon" />
              </div>

              <button
                className="pswdboxsubmit"
                onClick={() => {
                  handleUpdateDetails();
                  handleChangePassword();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}

        <div className="dash_complete_div">
          <Sidenavbar links={sidenav} dash_state={0} />

          <div className="profile-sec">
            {activeTab === "profile" && (
              <div>
                <Underline heading={"Profile Details"} />

                <div className="dash_detail_grid_holder">
                  <div className="trial_dash detail_grid detail_item_1 bgcolour_var_3">
                    <div className="detail_body txcolour_var_3 ">
                      {stud_details.studentname}
                    </div>
                    <div className="detail_head">Name</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_2 bgcolour_var_5">
                    <div className="detail_body txcolour_var_2 dash-bar">
                      <Progressbar
                        key={1}
                        percent1={(cgpa ?? 0) * 10}
                        display1={cgpa}
                        symbol=""
                        heading="CGPA"
                      />
                    </div>
                    <div className="detail_head">CGPA</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_3 bgcolour_var_2">
                    <div className="detail_body txcolour_var_2 dept_name">
                      {dept !== undefined ? dept.toUpperCase() : ""}{" "}
                      {stud_details.batch}
                    </div>
                    <div className="detail_head">Department</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_4 bgcolour_var_3">
                    <div className="detail_body txcolour_var_3">
                      {stud_details.regno}
                    </div>
                    <div className="detail_head">Register Number</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_5 bgcolour_var_3">
                    <div className="detail_body txcolour_var_3 d-emis">
                      {stud_details.emis_no}
                    </div>
                    <div className="detail_head">UMIS Number</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_6 bgcolour_var_2">
                    <div className="detail_body ">{stud_details.gender}</div>
                    <div className="detail_head">Gender</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_7 bgcolour_var_3">
                    <div className="detail_body txcolour_var_3">
                      {stud_details.blood_grp}
                    </div>
                    <div className="detail_head">Blood Group</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_8 bgcolour_var_2">
                    <div className="detail_body txcolour_var_2">
                      {stud_details.dob}
                    </div>
                    <div className="detail_head">DOB</div>
                  </div>

                  <div className="trial_dash detail_grid detail_item_9 bgcolour_var_2">
                    <div className="detail_body txcolour_var_2">
                      {stud_details.phoneno}
                    </div>
                    <div className="detail_head">Mobile Number</div>
                  </div>
                  <div className="trial_dash detail_grid detail_item_10 bgcolour_var_3">
                    <div className="detail_body txcolour_var_3">
                      {stud_details.mailid}
                    </div>
                    <div className="detail_head">Email</div>
                  </div>
                </div>

                <div className="logout_button">
                  <a className="log_link" href="/logout">
                    Logout
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Dash_radialmenu menu_links={radmenu} />
    </div>
  );
};

export default Dashboard;   